import { render, staticRenderFns } from "./MealForm.vue?vue&type=template&id=1636dab6&"
import script from "./MealForm.vue?vue&type=script&lang=js&"
export * from "./MealForm.vue?vue&type=script&lang=js&"
import style0 from "./MealForm.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports